import axios from 'axios';

export const deleteCodeByIdentifier = async (identifier: string) => {
    const url = `/api/qrcode/${identifier}/`;

    return await axios.delete(url);
};

export const deleteCodeByIdentifiers = async (identifiers: string[]) => {
    const url = `/api/qrcode/deleteList`;

    return await axios.post(url, {identifiers: identifiers});
};
